import React from "react"
import { ADD } from "../../include/constant"
import NavigationForm from "../common/NavigationForm"
import SuperAdminHeader from "./Header"

const SuperAdminAddNavigation = ({ from }) => {
    return <SuperAdminHeader >
        <div className="fixed-top-bar">
            <NavigationForm
                title={"Add " + from}
                type={ADD}
                from={from}
            />
        </div>
    </SuperAdminHeader>
}

export default SuperAdminAddNavigation